<template>
    <div class="gallery-modal" v-if="isOpen">
        <div class="gallery-modal-content">
            <div class="viewer">
                <component
                    :is="currentMediaType"
                    :media="currentMedia"
                    @loaded="mediaLoaded"
                />
            </div>

            <div class="gallery-sidebar">
                <div
                    v-for="(image, index) in mediaItems"
                    :key="index"
                    class="thumbnail"
                    :class="{'active': currentIndex === index}"
                    @click="selectMedia(index)"
                >
                    <img
                        v-if="!!image?.thumbnail"
                        :src="image.thumbnail"
                        :alt="`image ${index}`"
                        loading="lazy"
                        @load="thumbnailLoaded"
                    >
                    <img
                        v-else-if="!!image?.poster"
                        :src="image.poster.thumbnail.url"
                        :alt="`image ${index}`"
                        loading="lazy"
                        @load="thumbnailLoaded"
                    >
                </div>
            </div>

            <button
                class="close-btn"
                @click="$emit('close', true)"
            ><i class="icon-close"></i></button>
        </div>
    </div>
</template>

<script>

import { defineComponent } from 'vue'
import ImageViewer from './ImageViewer.vue'
import VideoPlayer from './VideoPlayer.vue'

export default defineComponent({
    name: "GalleryModal",
    props: {
        // Добавляем пропс для внешнего списка медиа
        externalMediaList: {
            type: Array,
            required: true,
            default: () => []
        },
        current: {
            type: Number,
            default: 0
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close'],
    components: {
        ImageViewer,
        VideoPlayer
    },
    data() {
        return {
            currentIndex: 0,
            // mediaItems: [],
            loading: false,
            // currentMedia: {},
            // currentMediaType: ''
        }
    },
    computed: {
        mediaItems() {
            // Используем внешний список медиа
            return this.externalMediaList
        },
        currentMedia() {
            return this.mediaItems[ this.currentIndex ] || {}
        },
        currentMediaType() {
            return !!this.currentMedia?.url ? 'video-player' : 'image-viewer'
        }
    },
    mounted() {
        this.currentIndex = this.current
    },
    methods: {
        openGallery() {
            this.isOpen = true
        },
        closeGallery() {
            this.isOpen = false
        },
        selectMedia(index) {
            if (index >= 0 && index < this.mediaItems.length) {
                this.currentIndex = index
            }
        },
        mediaLoaded() {
            // Логика после загрузки медиа
        },
        thumbnailLoaded() {
            // Логика после загрузки миниатюры
        }
    },
})
</script>

<style scoped>

</style>